// Hideo - script editor: the counter under the title (words and time). Ported from updScriptStats in the legacy
// editor.js (golden tests: tests/editor-markdown.test.ts).
import { t, tn } from '../../i18n'
import { READ_WPM, countWords, spokenSec } from '../../utils/words'
import { PAGE_LINES, paginate, parseFountain } from './fountain'

/** Words of the editor's text (runs of non-spaces) */
export const editorWords = countWords

/** "{n} words · ~{m} min read" for a Blog article (about 200 words a minute, at least 1 minute); otherwise the spoken
 *  time, at 2.5 words a second: "{n} words · ~{m} min {s} s spoken" */
export function scriptStats(text: string, blog: boolean): string {
  const w = editorWords(text)
  if (blog) return tn(w, '{n} word · ~{m} min read', '{n} words · ~{m} min read', { m: Math.max(1, Math.round(w / READ_WPM)) })
  const sec = spokenSec(w)
  return tn(w, '{n} word · ~{m} min {s} s spoken', '{n} words · ~{m} min {s} s spoken', { m: Math.floor(sec / 60), s: sec % 60 })
}

/** Fountain mode: "{n} pages · ~{m} min on screen", by the screenplay rule of one page a minute (the last page counted
 *  as far as it goes, at least 1 minute) */
export function fountainStats(src: string): string {
  const { pages, lines } = paginate(parseFountain(src))
  if (!pages.length) return t('0 pages')
  return tn(pages.length, '{n} page · ~{m} min on screen', '{n} pages · ~{m} min on screen', { m: Math.max(1, Math.round(lines / PAGE_LINES)) })
}
